import ApiHelperMixin from './api.helper'

const mixins = {
  ApiHelperMixin,
}

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Object.values(mixins).forEach(mixin => Vue.mixin(mixin))
  },
}
